const getMenus = state => state.menuList.data;

export { getMenus };
